import React from "react";

//images
import Image from "../assets/rup_ava.svg";

//icons
import { FaGithub, FaYoutube, FaDribbble, FaLinkedin } from "react-icons/fa";

//type animation
import { TypeAnimation } from "react-type-animation";

//motion
import { motion } from "framer-motion";

//variants
import { fadeIn } from "../variants";

import { Link } from "react-scroll";

const Banner = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          {/* text  */}
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[55px] font-bold leading-[0.8] lg:text-[110px]"
            >
              RUPAM <span>PAL</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4">I am a</span>
              <TypeAnimation
                sequence={[
                  "Developer",
                  2000,
                  "Designer",
                  2000,
                  "Youtuber",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 max-w-lg mx-auto lg:mx-0"
            >
              {/* I am a passionate and highly motivated full-stack developer with a
              strong foundation in both front-end and back-end technologies.
              Currently, as a fresher my proficiency in React JS, allows me to
              create dynamic and responsive user interfaces with ease. I am
              well-versed in Node.js, Express.js and MongoDB, which enables me
              to create robust and efficient server-side applications. */}
              I am a passionate and highly motivated full-stack developer currently working in Angular
              in frontend with Dot Net Core in backend in Euromonitor International. I also have expertise in
              MERN stack having worked on multiple projects. I also teach students about competitive programming through
              my youtube channel and help them in their interview preparation. 
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <Link to="contact" activeClass="active" smooth={true} spy={true}>
                <button className="btn btn-lg">Contact me</button>
              </Link>
              <a
                href="https://drive.google.com/file/d/16GpW7RvSC1m7M-2EbpeSGoXENKINRVqi/view?usp=drivesdk"
                target="_blank"
                className="text-gradient btn-link"
              >
                My Resume
              </a>
            </motion.div>
            {/* socials  */}
            <motion.div
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <a
                href="https://www.youtube.com/channel/UCt4iyFQadjuGmHnNaI6Yhfg"
                target="_blank"
              >
                <FaYoutube />
              </a>
              <a
                href="https://github.com/Rupam0710?tab=repositories"
                target="_blank"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/rupam-pal-0213a31a9/"
                target="_blank"
              >
                <FaLinkedin />
              </a>
            </motion.div>
          </div>
          {/* image  */}
          <motion.div
            variants={fadeIn("down", 0.5)}
            initial="hidden"
            whileInView={"show"}
            className="hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]"
          >
            <img src={Image} alt="" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
